import { Typography, styled } from '@mui/material';
import ReactPlayer from 'react-player';

export const CandidatesTitle = styled(Typography)(({ theme }) => ({}));

export const Video = styled(ReactPlayer)(() => ({
  width: '100%',
  height: '100%',
  objectFit: 'fill',
}));
